import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const UserSettingsIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="UserSettingsIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/user-settings">
            <path
                fill="none"
                id="Vector"
                d="M10.1504 15H6.15039C5.08952 15 4.07211 15.4214 3.32196 16.1716C2.57182 16.9217 2.15039 17.9391 2.15039 19V21M21.8504 16.4L20.9504 16.1M15.3504 13.9L14.4504 13.6M16.7504 18.7L17.0504 17.8M19.2504 12.2L19.5504 11.3M19.7504 18.7L19.3504 17.7M16.9504 12.3L16.5504 11.3M14.4504 16.6L15.4504 16.2M20.8504 13.8L21.8504 13.4M21.1504 15C21.1504 16.6569 19.8072 18 18.1504 18C16.4935 18 15.1504 16.6569 15.1504 15C15.1504 13.3431 16.4935 12 18.1504 12C19.8072 12 21.1504 13.3431 21.1504 15ZM13.1504 7C13.1504 9.20914 11.3595 11 9.15039 11C6.94125 11 5.15039 9.20914 5.15039 7C5.15039 4.79086 6.94125 3 9.15039 3C11.3595 3 13.1504 4.79086 13.1504 7Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
